import { environment } from '../environments/environment';
import { OpenIdConfiguration } from 'angular-auth-oidc-client';

export const authConfig: OpenIdConfiguration = {
  authority: environment.Authority_URL,
  redirectUrl: window.location.origin,
  postLogoutRedirectUri: window.location.origin,
  clientId: environment.Client_ID,
  scope: 'email openid',
  responseType: 'code',
  silentRenew: true,
  useRefreshToken: true,
  renewTimeBeforeTokenExpiresInSeconds: 30
}
